/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_SendInputs */

const en_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const fr_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const de_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schicken`)
};

const it_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviare`)
};

const ru_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправлять`)
};

const es_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const zh_cn2_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送`)
};

const ja_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信`)
};

const hi_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भेजना`)
};

const pt_pt2_live_caption_send = /** @type {(inputs: Live_Caption_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Live_Caption_SendInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_send = /** @type {((inputs?: Live_Caption_SendInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_SendInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_send(inputs)
	if (locale === "de") return de_live_caption_send(inputs)
	if (locale === "it") return it_live_caption_send(inputs)
	if (locale === "ru") return ru_live_caption_send(inputs)
	if (locale === "es") return es_live_caption_send(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_send(inputs)
	if (locale === "ja") return ja_live_caption_send(inputs)
	if (locale === "hi") return hi_live_caption_send(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_send(inputs)
	return en_live_caption_send(inputs)
});